module.exports = __webpack_public_path__ + "img/stock2.e30eb3fb.png";